import { CaretDownOutlined, DownOutlined, ShopFilled } from "@ant-design/icons";
import { Dropdown, Space } from "antd";
import { NavLink } from "react-router-dom";

const AddFunctionality = () => {
  const items = [
    {
      label: <NavLink to="/integrations">Integrations</NavLink>,
      key: "1",
    },
    {
      label: <NavLink to="/additionalservices">Additional</NavLink>,
      key: "2",
    },
  ];
  return (
    <Dropdown
      menu={{
        items,
      }}
      trigger={["click"]}
    >
      <a onClick={(e) => e.preventDefault()}>
        <Space>
          <ShopFilled style={{ fontSize: "20px" }} /> Add Functionality
          <DownOutlined />
        </Space>
      </a>
    </Dropdown>
  );
};
export default AddFunctionality;
